// extracted by mini-css-extract-plugin
export default {"search":"SearchInput_search__RNjk9","icon":"SearchInput_icon__NvTDQ","input":"SearchInput_input__UoIOm","clear":"SearchInput_clear__nyZF-"};